// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__N9Yus","box":"WorkspacesBox_box__2dI27","node":"WorkspacesBox_node__1VlDA"};